import { BrowserRouter as Router, Routes, Route, Navigate }   from "react-router-dom";
import Layout                                                 from "./components/Layout";
import Dashboard                                              from "./components/Dashboard";
import Users                                                  from "./pages/Users";
import Drones                                                 from "./pages/Drones";
import Parts                                                  from "./pages/Parts";
import SellerDetails                                          from "./pages/SellerDetails";
import Accessories                                            from "./pages/Accessories";
import Services                                               from "./pages/Service";
import Rentals                                                from "./pages/Rental";
import Orders                                                 from "./pages/OrderPage";
import HirePilot                                              from "./pages/HirePilot";
import HireJob                                                from "./pages/HireJob";
import Regulatory                                             from "./pages/Regulatory";
import Settings                                               from "./pages/Settings";
import Popup                                                  from "./pages/Popup";
import PilotBookingStatus                                     from "./pages/PilotBookingStatus";
import ServiceBookingStatus                                   from "./pages/ServiceBookingStatus";
import DroneBookingStatus                                     from "./pages/DroneBookingStatus";
import JobApplicationView                                     from "./pages/JobApplicationView";
import TrainingBookingStatus                                  from "./pages/TrainingBookingStatus";
import RegisteredBuyer                                        from "./pages/RegisteredBuyer";
import SellerApprovalPanel                                    from "./pages/SellerApprovalPanel";
import ReturnProductsForm                                     from "./pages/ReturnProductsForm";
import RefundManagement                                       from "./pages/RefundManagement";
import DroneRentalForm                                        from "./pages/DroneRentalForm";
import BuyersAddress                                          from "./pages/BuyerAddress";
import BuyerCart                                              from "./pages/BuyerCart";
import ManageAdmins                                           from "./pages/ManageAdmins";
import TaxSettingsForm                                        from "./pages/Tax";
import Login                                                  from "./pages/Login";
import ProtectedRoute                                         from "./components/ProtectedRoute";
import "./App.css";
import TrainingPage                                           from "./pages/Training";
import Announcement                                           from "./pages/Announcement";
import BuyerPilot                                             from "./pages/BuyerPilot";
import TermsManager                                           from "./pages/TermsAndConditions";
import PolicyManager                                          from "./pages/PolicyManager";
import SplashScreen                                           from "./pages/Splashscreen";
import AppConfigPage                                          from "./pages/AppUpdate";
import BulkOrder                                              from "./pages/BulkOrder";
export default function App() {
  return (
    <Router>
      <Routes>
        {/* Public route */}
        <Route path="/login" element={<Login />} />

        {/* Protected routes */}
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="users" element={<Users />} />
          <Route path="drones" element={<Drones />} />
          <Route path="parts" element={<Parts />} />
          <Route path="accessories" element={<Accessories />} />
          <Route path="services" element={<Services />} />
          <Route path="rentals" element={<Rentals />} />
          {/* <Route path="sold-product" element={<SoldProducts />} /> */}
          <Route path="regulatory" element={<Regulatory />} />
          <Route path="settings" element={<Settings />} />
          <Route path="popup" element={<Popup />} />
          <Route path="pilot" element={<HirePilot />} />
          <Route path="job" element={<HireJob />} />
          <Route path="orders" element={<Orders />} />
          <Route path="seller" element={<SellerApprovalPanel />} />
          <Route path="PilotBookingStatus" element={<PilotBookingStatus />} />
          <Route path="ServiceBookingStatus" element={<ServiceBookingStatus />} />
          <Route path="JobApplicationView" element={<JobApplicationView />} />
          <Route path="TrainingBookingStatus" element={<TrainingBookingStatus />} />
          <Route path="DroneBookingStatus" element={<DroneBookingStatus />} />
          <Route path="RegisteredBuyer" element={<RegisteredBuyer />} />
          <Route path="manage-admins" element={<ManageAdmins />} />
          <Route path="training-page" element={<TrainingPage />} />
          <Route path="buyer-address" element={<BuyersAddress />} />
          <Route path="buyer-cart" element={<BuyerCart />} />
          <Route path="drone-rental-form" element={<DroneRentalForm />} />
          <Route path="return-product" element={<ReturnProductsForm />} />
          <Route path="refund-management" element={<RefundManagement />} />
          <Route path="tax" element={<TaxSettingsForm />} />
          <Route path="seller-details" element={<SellerDetails />} />
          <Route path="announcement" element={<Announcement />} />
          <Route path="buyer_pilot" element={<BuyerPilot />} />
          <Route index element={<Navigate to="dashboard" replace />} />
            <Route path="terms" element={<TermsManager />} />
            <Route path="policies" element={<PolicyManager />} />
            <Route path="splash-screen" element={<SplashScreen />} />
            <Route path="app-config" element={<AppConfigPage />} />
            <Route path="bulk-order" element={<BulkOrder />} />
        </Route>

        {/* Default redirect */}
        <Route path="/*" element={<Navigate to="/login" replace />} />
      </Routes>
    </Router>
  );
}